import { render } from "./NewAndPromotionList.vue?vue&type=template&id=9f69e732"
import script from "./NewAndPromotionList.vue?vue&type=script&lang=js"
export * from "./NewAndPromotionList.vue?vue&type=script&lang=js"

import "./NewAndPromotionList.vue?vue&type=style&index=0&id=9f69e732&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__